import styled from '@emotion/styled'
export default styled('div')`
  font-weight: normal;
  font-size: 12px;
  color:#7F8FA4;
  font-style:italic;
`
